import React from 'react';
import Button from '../common/Button';

const DisclaimersSection = () => {
  return (
    <section id="disclaimers" className="py-[70px] lg:py-[96px]">
      <div className="w-full max-w-[1120px] mx-auto px-4">
        <div className="max-w-[720px] mb-8 lg:mb-[34px]">
          <h2 className="text-[clamp(2.2rem,3vw,3rem)]">Medical and religious guidance disclaimers</h2>
          <p className="text-[1.05rem] text-muted mt-4">
            Nisaa is a tracking and educational tool. It does not replace a clinician, emergency services, or a qualified Islamic scholar.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-[18px]">
          <article className="p-6 border border-line rounded-lg bg-paper flex flex-col items-start">
            <h3 className="mb-3 text-[1.35rem]">Medical disclaimer</h3>
            <p className="text-muted mb-6 flex-grow">
              Nisaa is not a medical device and does not provide diagnosis, treatment, contraception advice, fertility guarantees, or emergency care. Users should seek professional medical advice for symptoms, pregnancy concerns, fertility decisions or urgent health issues.
            </p>
            <Button variant="secondary" to="/disclaimer#medical" className="mt-auto">
              Read medical disclaimer
            </Button>
          </article>
          
          <article className="p-6 border border-line rounded-lg bg-paper flex flex-col items-start">
            <h3 className="mb-3 text-[1.35rem]">Religious disclaimer</h3>
            <p className="text-muted mb-6 flex-grow">
              Nisaa provides educational Islamic content and personal tracking support. It is not a fatwa service. Users should consult qualified scholars for rulings specific to their circumstances, madhab or local practice.
            </p>
            <Button variant="secondary" to="/disclaimer#religious" className="mt-auto">
              Read religious disclaimer
            </Button>
          </article>
        </div>
      </div>
    </section>
  );
};

export default DisclaimersSection;